"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RUNBOOK_RESOURCE_TYPES = void 0;
const RUNBOOK_RESOURCE_TYPES = exports.RUNBOOK_RESOURCE_TYPES = {
  ALERT_POLICY: 'alert_policy',
  ALERT_POLICY_TEMPLATE: 'alert_policy_template'
};